import { render, staticRenderFns } from "./ElTableDialog.vue?vue&type=template&id=ef9e80c0&"
import script from "./ElTableDialog.vue?vue&type=script&lang=js&"
export * from "./ElTableDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports